export default __webpack_public_path__ + "static/media/fontawesome-webfont.f7f1738c.woff";